import * as ActionGenerics from "../../Common/actionGenerics";
import * as ActionTypes from "./actionTypes";
import * as StoreTypes from "../DataTypes/storeTypes";
import { IStore, Step } from "../DataTypes/storeTypes";
import * as RequestTypes from "../DataTypes/requestTypes";
import * as Fetch from "../../Common/fetch";
import * as ServiceTypes from "../DataTypes/serviceTypes";
import * as Actions from "./actions";
import * as Notifications from "../../Common/Notifications/helper";
import { post } from "../../Common/fetch";
import { IStripeFeeData } from "../DataTypes/serviceTypes";
import { setPageLoading } from "./actions";

function selectServiceInternal(id: number): ActionGenerics.IParamAction<ActionTypes.Actions, number> {
    return { type: ActionTypes.Actions.SelectService, parameter: id };
}

export function selectService(id: number) {
    return (dispatch, getState: () => StoreTypes.IStore) => {
        dispatch(selectServiceInternal(id));
        dispatch(Actions.flushSteps([Step.Provider, Step.When]));

        dispatch(Actions.moveNext());
    };
}

export function tryToApplyDeposit() {
    return (dispatch, getState: () => StoreTypes.IStore) => {
        const state = getState();
        const serviceInfo = state.stepsInfo[StoreTypes.Step.Service] as StoreTypes.IServiceStepInfo;
        if (serviceInfo.hasPortalDeposit) {
            dispatch(applyDeposit());
        }
    };
}

function updateServices(
    services: ServiceTypes.IServicesData
): ActionGenerics.IParamAction<ActionTypes.Actions, ServiceTypes.IServicesData> {
    return { type: ActionTypes.Actions.UpdateServices, parameter: services };
}

export function getServices(dispatch, state: StoreTypes.IStore) {
    const request: RequestTypes.IAppointmentRequest = {
        locationId: state.stepsInfo[StoreTypes.Step.Location].id,
    };

    return Fetch.post<ServiceTypes.IServicesData>(state.initialSettings.getServicesUrl, request)
        .then((data) => dispatch(updateServices(data)))
        .catch((data) => Notifications.error(data.message));
}

export function getAllServices(dispatch, state: StoreTypes.IStore) {
    return Fetch.post<ServiceTypes.IServicesData>(state.initialSettings.getAllServicesUrl, null)
        .then((data) => dispatch(updateServices(data)))
        .catch((data) => Notifications.error(data.message));
}

export function selectServiceCategory(category: string): ActionGenerics.IParamAction<ActionTypes.Actions, string> {
    return { type: ActionTypes.Actions.SelectServiceCategory, parameter: category };
}

export function applyClientDiscount(clientId: number): ActionGenerics.IParamAction<ActionTypes.Actions, number> {
    return { type: ActionTypes.Actions.ApplyClientDiscount, parameter: clientId };
}

export function applyDeposit(): ActionGenerics.IAction<ActionTypes.Actions> {
    return { type: ActionTypes.Actions.ApplyDeposit };
}

export function applyFullPayment(): ActionGenerics.IAction<ActionTypes.Actions> {
    return { type: ActionTypes.Actions.ApplyFullPayment };
}

export function applyTax(): ActionGenerics.IAction<ActionTypes.Actions> {
    return { type: ActionTypes.Actions.ApplyTax };
}

export function applyAmountStripeFee(
    data: IStripeFeeData
): ActionGenerics.IParamAction<ActionTypes.Actions, IStripeFeeData> {
    return { type: ActionTypes.Actions.ApplyAmountStripeFee, parameter: data };
}

export function applyTotalAmountStripeFee(
    data: IStripeFeeData
): ActionGenerics.IParamAction<ActionTypes.Actions, IStripeFeeData> {
    return { type: ActionTypes.Actions.ApplyTotalAmountStripeFee, parameter: data };
}

export function calculateStripeSurcharges() {
    return (dispatch, getState: () => StoreTypes.IStore) => {
        const state = getState();

        dispatch(setPageLoading(true));

        let promise: Promise<any> = Promise.resolve();

        const serviceInfo = state.stepsInfo[StoreTypes.Step.Service] as StoreTypes.IServiceStepInfo;

        promise = promise.then(() => calculateAmountStripeSurcharge(dispatch, state, serviceInfo));

        if (serviceInfo.hasPortalDeposit) {
            promise = promise.then(() => calculateTotalAmountStripeSurcharge(dispatch, state, serviceInfo));
        }

        promise.then(() => dispatch(setPageLoading(false)));
    };
}

function calculateAmountStripeSurcharge(dispatch, state: IStore, serviceInfo: StoreTypes.IServiceStepInfo) {
    return calculateStripeSurcharge(state, serviceInfo.amount, serviceInfo.id).then((data) => {
        dispatch(applyAmountStripeFee(data));
    });
}

function calculateTotalAmountStripeSurcharge(dispatch, state: IStore, serviceInfo: StoreTypes.IServiceStepInfo) {
    return calculateStripeSurcharge(state, serviceInfo.totalAmount, serviceInfo.id).then((data) => {
        dispatch(applyTotalAmountStripeFee(data));
    });
}

function calculateStripeSurcharge(state: IStore, amount: number, serviceId: number) {
    return post<any>(state.initialSettings.calculateStripeSurchargeUrl, { amount: amount, serviceId: serviceId });
}
